import type { MagentoOrderPrices } from "@jti/magento";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";
import { normalizeGetCustomerCartPricesResponse } from "../utils";

export const getCustomerCartOrderPricesEndpoint = (builder: MagentoApiBuilder) => ({
  getCustomerCartOrderPrices: builder.query<MagentoOrderPrices | undefined, string>({
    query: (cartId) => ({
      method: "getCustomerCartOrderPrices",
      params: [{ cartId }],
    }),
    transformResponse: normalizeGetCustomerCartPricesResponse,
    providesTags: [TAGS.CART_ORDER_PRICES],
  }),
});
